import React from 'react';

export default function TrackingLnik({ trackingNumber }) {
  if (!trackingNumber) {
    return null;
  }

  return (
    <a
      className="text-indigo-500 underline"
      href={`https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNumber}`}
      target="_blank"
      rel="noreferrer"
    >
      {trackingNumber}
    </a>
  );
}
